import axios from '../axios';

export default {
  getTerritory (options) {
    const params = {};

    if (options.page) {
      params.page = options.page;
    }

    if (options.limit) {
      params.limit = options.limit;
    }

    const query = [];
    for (const param in params) {
      query.push(encodeURIComponent(param) + '=' + encodeURIComponent(params[param]));
    }

    return new Promise((resolve, reject) => {
      axios.get('/territory?' + query.join('&'))
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  createTerritory (params) {
    return new Promise((resolve, reject) => {
      axios.post('/territory', params)
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  deleteTerritory (id) {
    return new Promise((resolve, reject) => {
      axios.delete(`/territory/${id}`)
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
};
